import { render, staticRenderFns } from "./lijibaoming.vue?vue&type=template&id=253a4616&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./lijibaoming.vue?vue&type=script&lang=js&"
export * from "./lijibaoming.vue?vue&type=script&lang=js&"
import style0 from "./lijibaoming.vue?vue&type=style&index=0&id=253a4616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a4616",
  null
  
)

export default component.exports